import { TCardMaster, useCardMasters, useDisplayMasters, useTotalMasters } from "models/CardMasterModel";
import { TCard } from "models/CardModel";

type TIsChartable = (card: TCard) => boolean;
const isChartable: TIsChartable = (card) => {
  return (
    card.kamoku_list?.length === 1 &&
    card.kamoku_list_mode === "show" &&
    card.subfield_list?.length === 1 &&
    card.subfield_list_mode === "show"
  );
};

const useCardTitle = (card: TCard | undefined) => {
  const { getCardMaster } = useCardMasters();
  const { getTotalMaster } = useTotalMasters();
  const { getDisplayMaster } = useDisplayMasters();

  if (!card) return null;
  const titleAry = [];
  titleAry.push(getCardMaster(card.card_master_id).title);
  card.total_id && titleAry.push(getTotalMaster(card.total_id).label);
  card.display_id && titleAry.push(getDisplayMaster(card.display_id).label);

  return titleAry.join(" ");
};

// [ToDo] このメソッドを新規に作ったので、他の場所で使える場所が有るはず。
const showFieldsList = (card: TCard, type: "kamoku" | "subfield", allList: any) => {
  if (!allList) return [];
  const settings = {
    list: type === "kamoku" ? card.kamoku_list : card.subfield_list,
    mode: type === "kamoku" ? card.kamoku_list_mode : card.subfield_list_mode,
  };
  if (type === "kamoku" && (!settings.list || !settings.mode)) return [];
  return Object.keys(allList).filter((k) => {
    const bool = settings.list?.includes(k);
    return settings.mode === "show" ? bool : !bool;
  });
};

// [ToDo] これじゃ駄目。フィールドの情報としてサーバから受け取らないと駄目。
const specialSubfields = [
  "KISYORAI",
  "KISYORAI_YOSANHI",
  "ZENNENDOUKIKANHI",
  "ZENNENDOUKIKANHI_PERCENT",
  "KISYORAI_TASSEIMITOSHIHI",
];
const hasSpecialSubfields = (subfields: any[]) => {
  return specialSubfields.filter((v) => subfields.includes(v)).length > 0;
};

const getThFilter = (card: TCard, sortKeys: any) => {
  if (!card || !card.thFilter) return false;
  return card.thFilter.find((f) => f.keys.toString() === sortKeys.toString());
};

const totalValuesUseNeeded = (card: TCard, cardMaster: TCardMaster) => {
  // [ToDo] ["1", "6"].includes(card.total_id) は駄目. totalMaster モデルを新設してマネージメントさせる必要が有る。恐らく他所でも。
  return cardMaster.isDaily || (card.vh_mode === "hn" && card.total_id && ["1", "6"].includes(card.total_id) === false)
    ? true
    : false;
};

export const CardUtil = {
  isChartable,
  useCardTitle,
  showFieldsList,
  hasSpecialSubfields,
  getThFilter,
  totalValuesUseNeeded,
};

export const getCardProps = (card: TCard, cardMaster?: TCardMaster) => {
  const kamokuList = card.kamoku_list && card.kamoku_list.length > 0 ? card.kamoku_list : [];
  const kamokuListMode = card.kamoku_list_mode ? card.kamoku_list_mode : "show";
  const kamokuSort = card.kamoku_sort && card.kamoku_sort.length > 0 ? card.kamoku_sort : [];
  const subfieldList =
    card.subfield_list && card.subfield_list.length > 0
      ? card.subfield_list
      : cardMaster && cardMaster.isWeekly
        ? Object.keys(cardMaster.subfields).filter((f) => f.indexOf("JISSEKICHI") > 0)
        : cardMaster && cardMaster.isDaily
          ? []
          : ["JISSEKICHI"];
  const subfieldListMode = card.subfield_list_mode ? card.subfield_list_mode : "show";
  const classifiedSubfields = {
    all: subfieldList,
    normal: subfieldList.filter((f) => !specialSubfields.includes(f)),
    special: subfieldList.filter((f) => specialSubfields.includes(f)),
  };
  const totalValueKeysList = card.total_value_keys && card.total_value_keys.length > 0 ? card.total_value_keys : [];
  const totalValueKeysListMode = card.total_value_keys_mode ? card.total_value_keys_mode : "show";
  const totalValueKeysSort =
    card.total_value_keys_sort && card.total_value_keys_sort.length > 0 ? card.total_value_keys_sort : [];

  const fromY = card.month?.fromY ? String(card.month.fromY) : null;
  const fromM = card.month?.fromM ? String(card.month.fromM) : null;
  const fromYM = fromY && fromM ? fromY + fromM.padStart(2, "0") : null;
  const toY = card.month?.toY ? String(card.month.toY) : null;
  const toM = card.month?.toM ? String(card.month.toM) : null;
  const toYM = toY && toM ? toY + toM.padStart(2, "0") : null;
  const includeM = card.month?.includeM ? card.month.includeM : [];

  // [ToDo] 返却している3つのpropsを、別々のメソッドにすべき？例えば monthProps だけ欲しい場合にはcardMasterが不要になり、依存関係が減る。
  return {
    kamokuProps: { list: kamokuList, mode: kamokuListMode, len: kamokuList.length, sort: kamokuSort },
    subfieldProps: { list: subfieldList, mode: subfieldListMode, len: subfieldList.length, classifiedSubfields },
    totalValueKeysProps: {
      list: totalValueKeysList,
      mode: totalValueKeysListMode,
      len: totalValueKeysList.length,
      sort: totalValueKeysSort,
    },
    monthProps: { fromYM, toYM, includeM },
  };
};

export type TCardProps = ReturnType<typeof getCardProps>;
